'use client';

import { Flexbox, Tooltip, Typography } from '@doc/ui-components';
import { AbbCaretDown, AbbInformationCircle2 } from '@doc/ui-components/icons';
import Cookies from 'js-cookie';
import { useRouter } from '@power-core/toolkit';
import type { ToolCardProps } from '../types/tool-card.type';
import { useSearchParams } from 'next/navigation';
import { useFilters } from '@/shared/filters/hooks/use-filters.hook';

export const ToolCard = ({ icon, link, text, tooltipText }: ToolCardProps) => {
	const router = useRouter();
	const params = useSearchParams();
	const locale = Cookies.get('NEXT_LOCALE') || 'en';
	const { setType } = useFilters();

	const handleClick = () => {
		router.push(`${locale}/${link}${params.size > 0 ? `?${params.toString()}` : ''}`);
		setType(link);
	};

	return (
		<Flexbox
			onClick={handleClick}
			items='center'
			className='relative w-full bg-white rounded-3xl cursor-pointer hover:shadow-lg dark:bg-card_dark'
		>
			{icon}
			<Flexbox items='center' className='absolute top-2 right-2 gap-2 z-10'>
				<Tooltip content={tooltipText}>
					<AbbInformationCircle2 color='var(--color-accent)' />
				</Tooltip>
				<Typography tag='h5' size='text-2xl' weight='font-semibold' className='text-dark! dark:text-n700_text_dark_mode!'>
					{text}
				</Typography>
				<AbbCaretDown size={24} className='-rotate-90 bg-white rounded-sm' color='var(--color-n600_text)' />
			</Flexbox>
		</Flexbox>
	);
};
